import React from 'react'
import CSSModules from 'react-css-modules'

import styles from './avatar.scss'

const Avatar = props => {
	if (props.src) {
		return <img src={props.src} styleName='image' />
	} else {
		return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><circle cx="15" cy="15" r="15" fill="#EDF1F5"/><circle cx="15" cy="11.5" r="5.5" fill="#D2D9DC"/><path d="M5.8 26.9c2.5 2 5.7 3.1 9.2 3.1 3.5 0 6.6-1.2 9.2-3.1-.5-4.9-3.3-8.6-8.8-8.6-5.3-.1-9 3.7-9.6 8.6z" fill="#D2D9DC"/></svg>
	}
}

export default CSSModules(Avatar, styles, {allowMultiple: true})
